const extraStyleRoutes = [
  {
    path: '/extra-style',
    name: 'extra-style',
    component: () => import('@/views/extra-style/extra-style'),
    meta: {
      needLogin: true,
      limitMarket: ['IAM']
    }
  },
  {
    path: '/extra-style-center',
    name: 'extra-style-center',
    component: () => import('@/views/extra-style/extra-style-center'),
    meta: {
      needLogin: true,
      limitMarket: ['IAM']
    }
  },
  {
    path: '/extra-style-ranking',
    name: 'extra-style-ranking',
    component: () => import('@/views/extra-style/extra-style-ranking'),
    meta: {
      needLogin: true,
      limitMarket: ['IAM']
    }
  },
  {
    path: '/extra-style-template',
    name: 'extra-style-template',
    component: () => import('@/views/extra-style/extra-style-template'),
    meta: {
      needLogin: true,
      limitMarket: ['IAM']
    }
  },
  {
    path: '/extra-style/upload-image',
    name: 'extra-style-upload-image',
    component: () => import('@/views/extra-style/extra-style-upload-image'),
    meta: {
      needLogin: true,
      limitMarket: ['IAM']
    }
  },
  {
    path: '/extra-style/photo-preview',
    name: 'extra-style-photo-preview',
    component: () => import('@/views/extra-style/extra-style-photo-preview'),
    meta: {
      // needLogin: true,
      // limitMarket: ['IAM']
    }
  },
  {
    path: '/extra-style/photo-support',
    name: 'extra-style-photo-support',
    component: () => import('@/views/extra-style/extra-style-photo-support'),
    meta: {
      needWxAuth: true
    }
  }
]

export default extraStyleRoutes
